import React, { useState, useEffect } from "react";
import API from "../../API";
import { Header } from 'react-frontier2';
import { useParams } from "react-router-dom";
import { SidebarContainer } from "../../components";
import { useTitle } from "@arema/components/Hooks";
import { Promoter } from "../../AdminClasses";

import PromoterView from './PromoterView';
import PromoterContactList from './PromoterContactList';
import PromoterBanksList from './PromoterBanksList';
import PromoterEvents from './PromoterEvents';
import PromoterBalanceList from './PromoterBalanceList';

const PromoterContainer = () => {
	var { setTitle } = useTitle();
	var params = useParams<{ id: string }>();
	var [loadError, setLoadError] = useState<string>(null);
	var [promoter, setPromoter] = useState<Promoter>(null);

	useEffect(()=>{
		if(!promoter){
			API.getPromoter(parseInt(params.id)).then(res=>{
				if(res.error) return setLoadError(res.message);
				setPromoter(res.data);
				if(res.data) setTitle(res.data.promoter_name)
			}).catch(err=>{
				return setLoadError('Hubo un error inesperado cargando los datos del promotor (LCL-1)');
			});
		}
	}, [])

	if(loadError){
		return <Header text="Error" subtext={loadError} iconName='face-frown-open' />
	}else if(!promoter){
		return <Header loading text="Cargando promotor" />
	}
	
	var onEditPromoter = (prom: Promoter)=>{
		setPromoter(prom);
	}

	return <SidebarContainer 
		header={'Editar promotor'}
		routes={[
			{ url: `/promoters/${params.id}`, component: PromoterView },
			{ url: `/promoters/${params.id}/contacts`, component: PromoterContactList },
			{ url: `/promoters/${params.id}/accounts`, component: PromoterBanksList },
			{ url: `/promoters/${params.id}/events`, component: PromoterEvents },
			{ url: `/promoters/${params.id}/income`, component: PromoterBalanceList },
			/* { url: `/promoters/${params.id}/contacts/:id`, render: PromoterContactCreate }, */
		]}
		routeParams={{
			promoter,
			promoter_id: params.id,
			onEditPromoter,
		}}
		items={[
			{ text: 'Detalles', icon: 'edit', url: `/promoters/${params.id}` },
			{ text: 'Contactos', icon: 'address-book', url: `/promoters/${params.id}/contacts` },
			{ text: 'Cuentas Bancarias', icon: 'money-bill', url: `/promoters/${params.id}/accounts` },
			{ text: 'Eventos', icon: 'theater-masks', url: `/promoters/${params.id}/events` },
			{ text: 'Estado de cuenta', icon: 'file-invoice-dollar', url: `/promoters/${params.id}/income` },
		]}
		contentHeader={(null)}
	/>
}

export default PromoterContainer;